import { Record } from 'immutable';

const properties = {
  token: '',
  isNew: false,
};

export default class Auth extends Record(properties, 'Auth') implements Auth {
  public readonly token!: string;

  public readonly isNew!: boolean;
}
